import React from 'react';

import { Tag as AntTag } from 'antd';
import styled from 'styled-components';

interface TagProps {
  text: string;
  color?: string;
  backgroundColor?: string;
}

interface StyledTagProps {
  $backgroundColor?: string;
  $textColor?: string;
}

const StyledTag = styled(AntTag)<StyledTagProps>`
  background-color: ${(props) => props.$backgroundColor || '#e6f4ff'};
  color: ${(props) => props.$textColor || 'var(--color-primary)'};
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  margin-right: 8px;
`

export const Tag: React.FC<TagProps> = ({ text, color, backgroundColor }) => {
  return (
    <StyledTag $textColor={color}
      $backgroundColor={backgroundColor}
    >
      {text}
    </StyledTag>
  )
}